import * as React from 'react'

function SvgItFolder(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path d="M20 6h-8l-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V8a2 2 0 00-2-2zm1 12a.9.9 0 01-1 1H4a.9.9 0 01-1-1V6a.9.9 0 011-1h5.6l1.7 1.7.3.3H20a.9.9 0 011 1zM4 8h16v1H4z" />
      <path fill="none" d="M0 0h24v24H0z" />
    </svg>
  )
}

export default SvgItFolder
